import React, { useRef, useEffect, useState } from 'react';
import * as R from 'ramda';
import $ from 'jquery';

import countriesList from 'iso-3166-1-alpha-2';
import { RegexFields } from '../../../../../../constants/utils/regexFields';
import OtherActivity from '../../../../../../constants/models/servicePayloads/otherActivity';
import {FrenchTypes} from '../../../../../../constants/utils/connectionTypes';
import ServiceData from '../../../../../../constants/models/serviceData';
import {ModalRetraiteSection} from './retraiteSection';

export const ModalRetraite = ({pensions, isLoading, userId, pensionDetails}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

	const [pensionList, setPensionList] = useState([...pensions]);
    useEffect(() => {
        setPensionList([...pensions]);
    }, [pensions]);

    function removeFromList(index){
        setPensionList(pensionList.filter(a => a !== pensionList[index]));
    }



	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);
    return (
        <div className="modal fade px-0" id="retraiteModal" aria-labelledby="retraiteModalLabel" aria-hidden="true">
            <div className="modal-dialog px-2 container-screen">
                <div className="modal-content">
                    <div className="modal-header" data-dismiss="modal" aria-label="Close">
                        <div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h1 className="sr-only visually-hidden">Information deceased</h1>
							<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="retraiteModalLabel">Retraité(e)</div>
                        </div>
                    </div>
                    <div className="modal-body scroll-default py-0">
                        <article className="card" id="retraite">
							<h3 className="sr-only visually-hidden">Retraité</h3>
                            
							{
								pensionList.map((pension, index) => {
									return (<ModalRetraiteSection pension={pension} initCollapsedState={false} index={index} isLoading={isLoading} removeFromList={removeFromList} pensionDetails={pensionDetails} countries={countries} key={index}/>)
								})
							}

							<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center pt-4 pb-1">
                                <h4 className="sr-only visually-hidden">Ajouter une RETRAITE/RÉVERSION</h4>
                                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" onClick={(e) => {
                                    let serviceData = new ServiceData({ userId: userId, serviceType: FrenchTypes.pension, serviceId: 'pension'+pensionList.length, payload: {
										professionalCategory: null,
										pensionBaseServiceId: null,
										pensionComplementServiceId: null,
										customPensionBase:  {
											name: null,
											address: {
												streetAddress: null,
												streetAddress2: null,
												streetAddress3: null,
												postalCode: null,
												addressLocality: null,
												addressCountry: null
											},
											function: null
										},
										customPensionComplement: {
											name: null,
											address: {
												streetAddress: null,
												streetAddress2: null,
												streetAddress3: null,
												postalCode: null,
												addressLocality: null,
												addressCountry: null
											},
											function: null
										}
									} });
                                    setPensionList([...pensionList, {...serviceData, collapsed: true}]);
                                }}>
                                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre RETRAITE/RÉVERSION
                                </button>
                            </footer>
                        </article>
                    </div>
                    <div className="modal-footer">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal" onClick={
                            (e) => {
                                e.preventDefault();
                                setPensionList([...pensions]);
                            }
                        }>Fermer</button>
                    </div>
                </div>
            </div>
        </div>
    )
}